import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import behandelingenData from "../data/behandelingen.json";

const Behandelingen = () => {
  const [behandelingen, setBehandelingen] = useState([]);

  useEffect(() => {
    setBehandelingen(behandelingenData);
  }, []);

  return (
    <>
      <div className="behandelingen-container">
        <div className="sidebar">
          <div className="sticky-container">
            <div className="sticky-content">
              <div className="sticky-title"></div>
              <ul>
                <li>Pijnloze behandeling</li>
                <li>Lichaamseigen stof</li>
                <li>15 jaar ervaring</li>
                <li>Snel en natuurlijk resultaat</li>
              </ul>
              <p>
                <img
                  src="https://www.queencenter.nl/images/star.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <img
                  src="https://www.queencenter.nl/images/star.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <img
                  src="https://www.queencenter.nl/images/star.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <img
                  src="https://www.queencenter.nl/images/star.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <img
                  src="https://www.queencenter.nl/images/star.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <br /> Wij scoren{" "}
                <a
                  href="https://www.google.com/search?q=queen+center&amp;client=firefox-b-d&amp;source=lnms&amp;sa=X&amp;ved=0ahUKEwjKqoz1-dniAhVKzqYKHVo1ALwQ_AUICygA&amp;biw=1440&amp;bih=733&amp;dpr=2#lrd=0x47c709aeeb9ce9e5:0xdc7d04e5f37e8a4a,1,,,"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  9,8 van 10
                </a>
                <br /> berekend uit 43 reviews.
              </p>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="hero-content">
            <div className="hero-text">
              <h1>Behandelingen</h1>
              <p>
                Esthetische behandelingen zoals lipcorrecties en
                huidverbetering, zorgvuldig uitgevoerd met kwaliteitsproducten.
              </p>
            </div>
            <img
              src="/images/bg_hero_queencenter.png"
              alt="Hero Background prijslijst"
              className="hero-image"
            />
          </div>
          <div className="behandelingen-cards">
            {behandelingen.map((behandeling, index) => {
              const { id, categorie, title, vanaf, price_1, image } =
                behandeling;

              return (
                <div key={index} className="behandeling-card">
                  <div className="card-header">
                    <h3>{categorie}</h3>
                    <img src={image} alt={title} className="card-image" />
                  </div>
                  <div className="card-body">
                    <h2>{title}</h2>
                  </div>
                  <div className="card-footer">
                    <p>
                      {vanaf} {price_1}
                    </p>
                    <Link to={`/behandelingen/${id}`}>
                      <img src="/images/icon_next.svg" alt="Icon Next" />
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Behandelingen;
